<template>
  <el-dialog :visible="visible" title="视频审核详情" width="400px" @close="close">
    <div class="mb-20">
      <el-button @click="getList" type="primary">刷新审核状态</el-button>
    </div>
    <el-table :data="datalist">
      <el-table-column prop="shopName" label="店铺">
        <template slot-scope="{ row }">
          <shop-info :value="row" label="shopName" iconLabel="shopIcon" />
        </template>
      </el-table-column>
      <el-table-column prop="stateDesc" label="上传状态"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { getTemuVideoInfo } from '@/api/prod/center';
import { mapGetters } from 'vuex';
import ShopInfo from '../../../BasicComps/ShopInfo.vue';

export default {
  components: { ShopInfo },
  name: 'video-state',
  props: {
    visible: Boolean,
    value: {
      type: [Object, Array],
      default: () => [],
    },
  },
  data() {
    return {
      datalist: [],
    };
  },
  computed: {
    ...mapGetters(['shops_all']),
    shopInfos({ shops_all }) {
      let shopInfos = {};
      shops_all.forEach(shop => {
        if (shop.source !== 'pddtemu') return;
        shopInfos[shop.id] = shop;
      });
      return shopInfos;
    },
  },
  watch: {
    visible(v) {
      if (!v) return;
      this.getList();
    },
  },
  methods: {
    getList() {
      if (!this.value) return;
      getTemuVideoInfo({ baseItemIds: this.value }).then(res => {
        let list = [];
        (res.data || []).forEach(item => {
          let videoInfo = item.videoInfo || [];
          let target = this.shopInfos[item.shopId];
          videoInfo.forEach(v => {
            list.push({
              shopId: item.shopId,
              shopIcon: target?.icon,
              shopName: target?.shortTitle || target?.title || '',
              state: v?.videoState,
              stateDesc: v?.videoStateDesc,
            });
          });
        });
        this.datalist = list;
      });
    },
    close() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
